import axios from "axios";
export default {
  state: {
    usuarios: [],
    isUsuariosLoading: false,
    eliminarUsuario: null,
  },
  mutations: {
    setUsuarios(state, payload) {
      state.usuarios = payload;
    },
    setUsuariosLoading(state, payload) {
      state.isUsuariosLoading = payload;
    },
    setEliminarUsuario(state, payload) {
      state.eliminarUsuario = payload;
    },
  },
  actions: {
    async getUsuarios(context, { idRol }) {
      context.commit("setUsuariosLoading", true);
      let { data } = await axios.get(`/usuarios`, {
        params: {
          id_rol: idRol,
        },
      });

      context.commit("setUsuarios", data);
      context.commit("setUsuariosLoading", false);
    },
  },
  getters: {
    getEliminarUsuario(state) {
      return state.eliminarUsuario;
    },
  },
};
